import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { BaseElement } from "../BaseElement";
import { styles } from "./MediaUploadBrowser.style";
import { JobDescription } from "../../JobQueueInterface";
import { until } from "lit/directives/until.js";
import { IPlace } from "../../models/Models";
import { formatPlaceAddress } from "../../Format";
import { formatDateTime } from "../../Format";
import { litIf } from "../LitUtils";
import { MediaUploadDesc } from "../../MediaLibrary";

@customElement("ds-media-upload")
export class MediaUpload extends BaseElement {
    static override styles = [styles];

    @property({ type: Object }) job?: JobDescription;

    @state() protected _deletePlace?: IPlace;
    @state() protected _deleteUploadDesc?: MediaUploadDesc;

    private _deleteUpload() {
        // remove the media from the place
        const place = this._deletePlace;
        const upload = this._deleteUploadDesc;
        if (place && upload) {
            this._kernel.mediaLibrary.deleteUpload(upload);
        }
        this._deletePlace = undefined;
        this._deleteUploadDesc = undefined;
    }

    private async _render() {
        if (this.job) {
            const mediaLibrary = this._kernel.mediaLibrary;
            const upload = await mediaLibrary.getUpload(this.job.userData.key);
            if (upload) {
                let placeAddress: string | undefined;
                let dateAdded: string | undefined;
                let placeName: string | undefined;
                let place: IPlace | undefined;
                const placeId = upload.userData.place;
                if (placeId) {
                    place = (await this._kernel.dataStore.read("places", placeId)) as IPlace;
                    if (place) {
                        placeName = place.data.name;
                        placeAddress = formatPlaceAddress(place);
                    }
                }
                const date = upload.userData.date;
                if (date) {
                    dateAdded = formatDateTime(date);
                }
                return html`<sl-card class="ds-box-shadow">
                    <div slot="header" class="flex-column">
                        <span>${placeName}</span>
                        ${litIf(!!placeAddress, () => html`<span>${placeAddress}</span>`)}
                        ${litIf(!!dateAdded, () => html`<span>${dateAdded}</span>`)}</sl-card>
                    </div>
                    ${litIf(
                        !!this._deleteUploadDesc,
                        () => html`
                            <div class="flex-column">
                                <span>This will permanently delete the file.</span
                                ><span>Press 'Confirm' to delete or 'Cancel' to keep.</span>
                            </div>
                        `,
                        () => html`<ds-media .media=${upload.media}></ds-media>`
                    )}
                    
                    <div slot="footer">
                    ${litIf(
                        !!this._deleteUploadDesc,
                        () =>
                            html` <div class="flex-row">
                                <sl-button
                                    variant="danger"
                                    @click=${() => {
                                        this._deleteUpload();
                                    }}
                                    >Confirm</sl-button
                                >
                                <sl-button
                                    variant="success"
                                    @click=${() => {
                                        this._deletePlace = undefined;
                                        this._deleteUploadDesc = undefined;
                                    }}
                                    >Cancel</sl-button
                                >
                            </div>`,
                        () =>
                            html`<sl-button
                                variant="danger"
                                @click=${() => {
                                    this._deletePlace = place;
                                    this._deleteUploadDesc = upload;
                                }}
                                >Delete</sl-button
                            >`
                    )}
                        
                    </div>
                </sl-card>`;
            }
        }
        return html``;
    }

    override render() {
        return html` <div class="flex-column">${until(this._render())}</div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-media-upload": MediaUpload;
    }
}
